import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  PasswordInput,
  BooleanInput,
  required,
  email,
  minLength,
  useNotify,
  useRedirect,
} from 'react-admin';
import { useState } from 'react';

const validatePasswordMatch = (value: string, allValues: any) => {
  if (value !== allValues.password) {
    return 'Passwords do not match';
  }
  return undefined;
};

export const AdminUserCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = () => {
    notify('Admin user created successfully');
    redirect('list', 'admin-users');
  };

  return (
    <Create mutationOptions={{ onSuccess }}>
      <SimpleForm>
        <TextInput
          source="username"
          validate={[required(), minLength(3)]}
          fullWidth
          helperText="Username must be at least 3 characters"
        />
        <TextInput
          source="email"
          validate={[required(), email()]}
          fullWidth
        />
        <SelectInput
          source="role_id"
          label="Role"
          validate={required()}
          choices={[
            { id: 1, name: 'Super Admin' },
            { id: 2, name: 'Admin' },
            { id: 3, name: 'Support' },
            { id: 4, name: 'Viewer' },
          ]}
        />
        <PasswordInput
          source="password"
          validate={[required(), minLength(8)]}
          fullWidth
          helperText="Password must be at least 8 characters"
        />
        <PasswordInput
          source="confirm_password"
          label="Confirm Password"
          validate={[required(), validatePasswordMatch]}
          fullWidth
        />
        <BooleanInput
          source="is_active"
          label="Active"
          defaultValue={true}
        />
      </SimpleForm>
    </Create>
  );
};
